/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {CheckMediaRequest} from "../model/check-media-request";
import {Icon} from "../model/icon";
import {SuccessResponse} from "../model/success-response";
import {UploadAttachmentRequest} from "../model/upload-attachment-request";
import {UploadAttachmentResponse} from "../model/upload-attachment-response";
import {UploadBlueprintForTrainingRoomGroup} from "../model/upload-blueprint-for-training-room-group";
import {UploadBlueprintForTrainingRoomGroupResponse} from "../model/upload-blueprint-for-training-room-group-response";
import {UploadFileRequest} from "../model/upload-file-request";
import {UploadIconRequest} from "../model/upload-icon-request";
import {UploadMediaRequest} from "../model/upload-media-request";
import {UploadMediaResponse} from "../model/upload-media-response";
import {UploadZipFileRequest} from "../model/upload-zip-file-request";

@Injectable({
    providedIn: "root",
})
export class SimUploadService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public checkUploadMedia(uploadMedia: CheckMediaRequest) {
        return super.post<UploadMediaResponse>(`/api/Upload/CheckUploadMedia`, uploadMedia);
    }

    public replaceMedia(uploadMedia: UploadMediaRequest) {
        let formData = this.createFormData(uploadMedia);
		return super.upload<UploadMediaResponse>(`/api/Upload/ReplaceMedia`, formData, {}, [], "events", true);
    }

    public uploadAndGetUsersExcel(uploadedUsersExcel: UploadFileRequest) {
        let formData = this.createFormData(uploadedUsersExcel);
		return super.upload<string>(`/api/Upload/UploadAndGetUsersExcel`, formData, {}, [], "events", true);
    }

    public uploadAttachment(uploadAttachment: UploadAttachmentRequest) {
        let formData = this.createFormData(uploadAttachment);
		return super.upload<UploadAttachmentResponse>(`/api/Upload/UploadAttachment`, formData, {}, [], "events", true);
    }

    public uploadBlueprintForTrainingRoomGroup(uploadRequest: UploadBlueprintForTrainingRoomGroup) {
        let formData = this.createFormData(uploadRequest);
		return super.upload<UploadBlueprintForTrainingRoomGroupResponse>(`/api/Upload/UploadBlueprintForTrainingRoomGroup`, formData, {}, [], "events", true);
    }
/**
 * Uploads an image icon.
 */ 

    public uploadIcon(uploadIcon: UploadIconRequest) {
        let formData = this.createFormData(uploadIcon);
		return super.upload<boolean>(`/api/Upload/UploadIcon`, formData, {}, [], "events", true);
    }

    public uploadMedia(uploadMedia: UploadMediaRequest) {
        let formData = this.createFormData(uploadMedia);
		return super.upload<UploadMediaResponse>(`/api/Upload/UploadMedia`, formData, {}, [], "events", true);
    }

    public uploadTextIcon(textIcon: Icon) {
        return super.post<void>(`/api/Upload/UploadTextIcon`, textIcon);
    }
/**
 * Example file format (csv)              UID                                 ;NAME 7eb24518-2ca6-13ff-3ae1-ed33dccb9028;TAG 1038 1f721a16-ceef-8089-6246-3e76e7a2eafc;TAG 1010 1b31dd15-839f-6de1-d2d6-a6ee6db6fc1e;TAG 1017             
 */ 

    public uploadTrackers(uploadTrackers: UploadFileRequest) {
        let formData = this.createFormData(uploadTrackers);
		return super.upload<void>(`/api/Upload/UploadTrackers`, formData, {}, [], "events", true);
    }

    public uploadUsersExcel(uploadedUsersExcel: UploadFileRequest) {
        let formData = this.createFormData(uploadedUsersExcel);
		return super.upload<void>(`/api/Upload/UploadUsersExcel`, formData, {}, [], "events", true);
    }

    public uploadWebPagePermissions(uploadWebPagePermissions: UploadFileRequest) {
        let formData = this.createFormData(uploadWebPagePermissions);
		return super.upload<void>(`/api/Upload/UploadWebPagePermissions`, formData, {}, [], "events", true);
    }

    public uploadZipFile(zipFile: UploadZipFileRequest) {
        let formData = this.createFormData(zipFile);
		return super.upload<SuccessResponse>(`/api/Upload/UploadZipFile`, formData, {}, [], "events", true);
    }
}